var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tooltip",
    {
      attrs: { bottom: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              _c(
                "div",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "sensor-status-indicator",
                      class: _vm.ledClass,
                      attrs: {
                        "data-testid": "sensor-status-led-" + _vm.ledColor,
                      },
                    },
                    "div",
                    attrs,
                    false
                  ),
                  on
                )
              ),
            ]
          },
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "div",
        { attrs: { "data-testid": "sensor-status-tooltip" } },
        [
          _vm.showsInactive
            ? _c(
                "div",
                { attrs: { "data-testid": "sensor-status-tooltip-message" } },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("tooltip.monitoring_point_inactive")) +
                      "\n    "
                  ),
                ]
              )
            : [
                _vm.tooltipMessage
                  ? _c(
                      "div",
                      {
                        class: { "font-weight-medium": _vm.isStale },
                        attrs: {
                          "data-testid": "sensor-status-tooltip-message",
                        },
                      },
                      [
                        _vm._v(
                          "\n        " + _vm._s(_vm.tooltipMessage) + "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasReceived
                  ? _c(
                      "div",
                      {
                        class: {
                          "sensor-status-indicator__stale": _vm.isStale,
                        },
                        attrs: {
                          "data-testid": "sensor-status-tooltip-last-received",
                        },
                      },
                      [
                        _c("div", [
                          _vm._v(_vm._s(_vm.$t("tooltip.last_reception"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            attrs: {
                              "data-testid":
                                "sensor-status-tooltip-last-received-value",
                            },
                          },
                          [
                            _c("sensor-last-reception", {
                              attrs: { sensor: _vm.sensor },
                            }),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }